module.exports = __webpack_public_path__ + "img/eur.svg";